"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const underline_1 = __importDefault(require("../../../components/underline"));
const detectDevice_1 = __importDefault(require("../../../utils/detectDevice"));
const helpers_1 = require("../../../utils/helpers");
const users_1 = require("../../../utils/users");
const RefundTextComponent_1 = __importDefault(require("../../../components/refundTextComponent/RefundTextComponent"));
const ConfirmPayStyle_1 = require("./ConfirmPayStyle");
const PaymentStyled_1 = require("../payment/PaymentStyled");
const bed_white_svg_1 = __importDefault(require("../../../assets/images/bed-white.svg"));
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
const TimeLeft_1 = __importDefault(require("../../../components/timeLeft/TimeLeft"));
const BookingService_1 = __importDefault(require("../../../services/BookingService"));
const ConfirmValuesContext_1 = require("../context/ConfirmValuesContext");
const ConfirmPay = () => {
    const confirmValuesContext = (0, ConfirmValuesContext_1.useConfirmValues)();
    const [userData, setUserData] = (0, react_1.useState)({});
    const { isMobile } = (0, detectDevice_1.default)(992);
    const history = (0, react_router_1.useHistory)();
    const [statusPayment, setStatusPayment] = (0, react_1.useState)('');
    const getUserInfor = (0, react_1.useCallback)(() => {
        const token = (0, users_1.getAccessToken)();
        if (token) {
            const user = (0, users_1.getUserData)();
            const bookId = (0, helpers_1.decrypty)(localStorage.getItem('XP360:beds_bookId'));
            if (bookId) {
                setUserData({
                    name: `${user.firstName} ${user.lastName}`,
                    email: user.email,
                    bookId,
                });
            }
        }
    }, []);
    const handleRedirect = (0, react_1.useCallback)(() => {
        localStorage.removeItem('last_page_before_confirmed_payment');
        history.push(RoutesPaths_1.routesPaths.myAccount + RoutesPaths_1.routesPaths.myReservesSubLink);
    }, []);
    (0, react_1.useEffect)(() => {
        localStorage.removeItem('last_page_before_login');
        const bookingId = (0, helpers_1.decrypty)(localStorage.getItem('XP360:bookingId'));
        if (!bookingId)
            handleRedirect();
        else
            (() => __awaiter(void 0, void 0, void 0, function* () {
                const bookinResponse = yield BookingService_1.default.getSpecificBooking(bookingId);
                if (!bookinResponse.isError)
                    setStatusPayment(bookinResponse.booking.statusPayment);
                else
                    setStatusPayment('WAITING_PAYMENT');
            }))();
    }, []);
    (0, react_1.useEffect)(() => {
        getUserInfor();
    }, [getUserInfor]);
    (0, react_1.useEffect)(() => {
        if ((0, helpers_1.decrypty)(localStorage.getItem('last_page_before_confirmed_payment')) !== RoutesPaths_1.routesPaths.paymentBooking)
            handleRedirect();
    }, []);
    (0, react_1.useEffect)(() => {
        var _a;
        const { confirmValues } = confirmValuesContext;
        if ((_a = confirmValues === null || confirmValues === void 0 ? void 0 : confirmValues.suite) === null || _a === void 0 ? void 0 : _a.buildingName) {
            document.title = `360 Suítes - ${confirmValues.suite.buildingName} - Reserva finalizada`;
        }
    }, [confirmValuesContext]);
    const statusPaymentHash = {
        WAITING_PAYMENT: 'aguardando pagamento',
        APPROVED: 'aprovado',
    };
    return (react_1.default.createElement("div", { style: { maxWidth: '1980px' } },
        react_1.default.createElement(antd_1.Col, { span: 24 },
            react_1.default.createElement(TimeLeft_1.default, { timeLeftServer: 0, textInformation: "Tempo restante para pagamento: ", startTimer: false }),
            react_1.default.createElement(PaymentStyled_1.ContainerBody, { disabled: false },
                react_1.default.createElement(antd_1.Col, { span: 24 },
                    react_1.default.createElement(ConfirmPayStyle_1.Text, { size: 48 }, "Reserva efetuada com sucesso"),
                    react_1.default.createElement(underline_1.default, { style: { marginBottom: '30px' } }),
                    react_1.default.createElement(antd_1.Row, null,
                        react_1.default.createElement(ConfirmPayStyle_1.Text, { size: 32, style: { fontWeight: 'bold' } }, `Olá, ${userData.name && userData.name.split(' ')[0]}`)),
                    react_1.default.createElement("hr", { style: { width: 0 } }),
                    react_1.default.createElement(antd_1.Row, null,
                        react_1.default.createElement(ConfirmPayStyle_1.Text, { size: 22, style: { width: isMobile ? '100%' : '70%' } },
                            `A sua reserva com código `,
                            react_1.default.createElement(ConfirmPayStyle_1.Text, { size: 22, style: { fontWeight: 500 } }, `${userData.bookId || ''}`),
                            ` consta com o status `,
                            react_1.default.createElement(ConfirmPayStyle_1.Text, { size: 22, style: { fontWeight: 500 } }, `${statusPaymentHash[statusPayment] || ''}`))),
                    react_1.default.createElement("hr", { style: { width: 0 } }),
                    react_1.default.createElement(antd_1.Row, null,
                        react_1.default.createElement(ConfirmPayStyle_1.Text, { size: 22, style: { width: isMobile ? '100%' : '70%' } },
                            "Ap\u00F3s a valida\u00E7\u00E3o do pagamento, a confirma\u00E7\u00E3o de reserva e as instru\u00E7\u00F5es de",
                            react_1.default.createElement("span", { style: { whiteSpace: 'nowrap' } }, " check-in "),
                            "ser\u00E3o enviadas para o e-mail",
                            react_1.default.createElement(ConfirmPayStyle_1.Text, { size: 22, style: { fontWeight: 500 } }, ` ${userData.email}`))),
                    react_1.default.createElement("hr", { style: { width: 0 } }),
                    react_1.default.createElement(antd_1.Row, null,
                        react_1.default.createElement(ConfirmPayStyle_1.Text, { size: 22 }, "Clique abaixo para conferir mais informa\u00E7\u00F5es sobre a sua reserva:"))),
                react_1.default.createElement("hr", { style: { width: 0 } }),
                react_1.default.createElement("div", { style: { width: isMobile ? '100%' : '45%', display: 'flex', justifyContent: 'center' } },
                    react_1.default.createElement(antd_1.Button, { type: "primary", style: { textAlign: 'left' }, onClick: handleRedirect },
                        react_1.default.createElement(PaymentStyled_1.CustomSVG, { svg: bed_white_svg_1.default }),
                        "Minhas Reservas")),
                react_1.default.createElement("hr", null),
                react_1.default.createElement(antd_1.Collapse, { style: { backgroundColor: '#f7f7f7' }, bordered: false, expandIconPosition: "right" },
                    react_1.default.createElement(antd_1.Collapse.Panel, { key: "1", showArrow: true, header: react_1.default.createElement(ConfirmPayStyle_1.Text, { size: 32 }, "Pol\u00EDtica de cancelamento") },
                        react_1.default.createElement(RefundTextComponent_1.default, { bookId: userData.bookId })))))));
};
exports.default = ConfirmPay;
ConfirmPay.propTypes = {
    reserveText: prop_types_1.default.string,
};
ConfirmPay.defaultProps = {
    reserveText: 'Obrigado por reservar conosco. Não é necessário entrar em contato com 360 Suítes, sua reserva está garantida! Todas as informações da reserva foram enviadas para',
};
